var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEhrNode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.70833 2.04297H10.75C11.4403 2.04297 12 2.60262 12 3.29297V11.6263C12 12.3166 11.4403 12.8763 10.75 12.8763H3.25C2.55965 12.8763 2 12.3166 2 11.6263V3.29297C2 2.60262 2.55965 2.04297 3.25 2.04297H4.29167V2.66797H3.25C2.90538 2.66797 2.625 2.94835 2.625 3.29297V11.6263C2.625 11.9709 2.90538 12.2513 3.25 12.2513H10.75C11.0946 12.2513 11.375 11.9709 11.375 11.6263V3.29297C11.375 2.94835 11.0946 2.66797 10.75 2.66797H9.70833V2.04297Z",
    fill: "#08A88E",
    stroke: "#08A88E",
    strokeWidth: 0.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.58594,
    y: 1.5,
    width: 4.83333,
    height: 1.91667,
    rx: 0.5,
    stroke: "#08A88E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.375 7.04297H5.125V8.29297H6.375V9.54297H7.625V8.29297H8.875V7.04297H7.625V5.79297H6.375V7.04297Z",
    fill: "#08A88E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEhrNode);
export default __webpack_public_path__ + "static/media/EHRNode.2df9ccc56ed3da7dea7e12798875c619.svg";
export { ForwardRef as ReactComponent };